import { createTypes, createAction } from "lib/action";

const LOAD_PLANT_PRODUCTS = createTypes("plantProduct", "load");
const SAVE_PLANT_PRODUCTS = createTypes("plantProduct", "save");
const EXPORT_PLANT_PRODUCTS = createTypes("plantProduct", "export");
const IMPORT_PLANT_PRODUCTS = createTypes("plantProduct", "import");

const loadPlantProducts = {
  request: (company_id, token) => createAction(LOAD_PLANT_PRODUCTS.REQUEST, { company_id, token }),
  success: data => createAction(LOAD_PLANT_PRODUCTS.SUCCESS, { data }),
  failure: err => createAction(LOAD_PLANT_PRODUCTS.FAILURE, { err }),
};

const savePlantProducts = {
  request: (payload, token) => createAction(SAVE_PLANT_PRODUCTS.REQUEST, { payload, token }),
  success: data => createAction(SAVE_PLANT_PRODUCTS.SUCCESS, { data }),
  failure: err => createAction(SAVE_PLANT_PRODUCTS.FAILURE, { err }),
};

const exportPlantProducts = {
  request: (params, token) => createAction(EXPORT_PLANT_PRODUCTS.REQUEST, { params, token }),
  success: data => createAction(EXPORT_PLANT_PRODUCTS.SUCCESS, { data }),
  failure: err => createAction(EXPORT_PLANT_PRODUCTS.FAILURE, { err }),
};

const importPlantProducts = {
  request: (file, token) => createAction(IMPORT_PLANT_PRODUCTS.REQUEST, { file, token }),
  success: data => createAction(IMPORT_PLANT_PRODUCTS.SUCCESS, { data }),
  failure: err => createAction(IMPORT_PLANT_PRODUCTS.FAILURE, { err }),
};

export {
  loadPlantProducts,
  savePlantProducts,
  exportPlantProducts,
  importPlantProducts,
  LOAD_PLANT_PRODUCTS,
  SAVE_PLANT_PRODUCTS,
  EXPORT_PLANT_PRODUCTS,
  IMPORT_PLANT_PRODUCTS,
};